import type { Meta, StoryObj } from "@storybook/react";

import GroupClassSeriesDetails from "@/ui/components/groupClasses/series/details/GroupClassSeriesDetails";
import { IllustrationName } from "@/ui/theme/icons/illustrations/groupClasses";

const StoryMeta: Meta<GroupClassSeriesDetailsProps> = {
  title: "Components/Group Classes/Series Details",
  component: GroupClassSeriesDetails,
  argTypes: {
    attendees: { control: "object" },
    dateRange: { control: "text" },
    description: { control: "text" },
    iconName: {
      control: "select",
      options: Object.values(IllustrationName),
    },
    isAppUserSupport: { control: "boolean" },
    isRecurring: { control: "boolean" },
    isSensitive: { control: "boolean" },
    nextStartDate: { control: "text" },
    recurrenceString: { control: "text" },
    timeRange: { control: "text" },
    title: { control: "text" },
  },
  args: {
    attendees: [
      {
        providerType: "Dietitian, RDN",
        userId: "providersUUID",
        userName: "George Washington",
        userType: "provider",
      },
    ],
    dateRange: "Jul 1 - Dec 31, 2024",
    description: "Come do Yoga for this group class. Meets every week!",
    iconName: "glasses",
    isAppUserSupport: false,
    isRecurring: true,
    isSensitive: false,
    nextStartDate: "Tuesday, August 31",
    recurrenceString: "Every Wednesday",
    timeRange: "12 - 1:30pm",
    title: "Yoga Group Class",
  },
};

type Story = StoryObj<GroupClassSeriesDetailsProps>;

const Primary: Story = {};

const SensitivePatient: Story = {
  args: {
    isAppUserSupport: false,
    isSensitive: true,
  },
};

const SensitiveUserProxy: Story = {
  args: {
    isAppUserSupport: true,
    isSensitive: true,
  },
};

const NotRecurring: Story = {
  args: {
    isRecurring: false,
  },
};

const NoEndDate: Story = {
  args: {
    endDate: undefined,
  },
};

export {
  NoEndDate,
  NotRecurring,
  Primary,
  SensitivePatient,
  SensitiveUserProxy,
};
export default StoryMeta;
